import { useNavigate } from 'react-router-dom';
import { FolderKanban, ListTodo, Bot } from 'lucide-react';
import type { Project } from '../hooks/useProjects';

interface ProjectCardProps {
  project: Project;
}

export default function ProjectCard({ project }: ProjectCardProps) {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(`/projects/${project.id}`)}
      className="flex flex-col items-start rounded-xl border border-slate-200 bg-white p-6 text-left transition-shadow hover:shadow-md"
    >
      <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-lg bg-slate-100">
        <FolderKanban className="h-5 w-5 text-slate-600" />
      </div>
      <h3 className="font-semibold text-slate-900">{project.name}</h3>
      <p className="mt-1 line-clamp-2 text-sm text-slate-500">
        {project.description || 'No description'}
      </p>
      <div className="mt-4 flex gap-4 text-xs text-slate-400">
        <span className="flex items-center gap-1">
          <ListTodo className="h-3.5 w-3.5" />
          {project.taskCount ?? 0} tasks
        </span>
        <span className="flex items-center gap-1">
          <Bot className="h-3.5 w-3.5" />
          {project.agentCount ?? 0} agents
        </span>
      </div>
    </button>
  );
}
